"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEXT_TYPE = exports.TOKENS = void 0;
var TOKENS = {
  DEFAULT_IMAGE_WIDTH: '100%',
  DEFAULT_IMAGE_HEIGHT: '100%',
  QUESTION: {
    SIZE: 'sub',
    BOLD: true,
    COLOR: 'greyDarker'
  },
  ICON: {
    CONTENT: {
      CLOSE: 'AddIcon',
      OPEN: 'RemoveIcon'
    },
    SIZE: 'titleSmall',
    COLOR: 'orangeDarkMedium'
  },
  ANSWER: {
    SIZE: 'sub',
    BOLD: false,
    COLOR: 'greyDarker'
  }
};
exports.TOKENS = TOKENS;
var TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    lineHeight: 'normal'
  },
  sub: {
    type: 'sub',
    size: 'small',
    lineHeight: 'large'
  },
  small: {
    type: 'small',
    size: 'XSmall',
    lineHeight: 'small'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;